import React, {useEffect, useState} from 'react';
import Header from "../../components/Private/Header";
import ModalDate from "../../components/Private/ModalDate"
import {useQuery} from "@tanstack/react-query";
import {request} from "../../lib/request";
import PaginationApp from "../../components/Pagination";

const FinancialTransactions = () => {
    const [page, setPage] = useState(1)
    const [state, setState] = useState({})

    useEffect(() => {
        setPage(1);
    }, [state.from_date, state.to_date]);

    const {data, isLoading} = useQuery({
        queryKey: ["Transaction", page, state.from_date, state.to_date],
        queryFn: async () => await request({
            url: `/restaurant/Transaction/filterPayment`,
            method: "get",
            query: {page, ...state},
        })
    })
    const orders = data?.data || [];

    const restaurantCreditBorder = "border-r-[10px] border-r-green-500";
    const restaurantDebitBorder = "border-r-[10px] border-r-red-500";


    return (
        <>
            <Header title="لیست تراکنش‌های مالی">
                <ModalDate setState={setState} state={state}/>
            </Header>
            <div className="flex items-center justify-end">
                <div
                    className="flex items-center gap-6 border border-Primary-950 rounded-xl w-fit p-3">
                    <p className="text-Primary-950 font-semibold text-sm">مجموع واریزی : </p>
                    <div className="flex items-center gap-2 ">
                        <p className="text-Primary-950 font-semibold text-sm">{Number(data?.total_amount).toLocaleString()}</p>
                        <p className="text-Primary-950 font-semibold text-sm">تومان</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-full gap-4 pt-4">
                {orders?.map((i) => {
                        const isCredit = i.status === "credit" || i.label === "بستانکار";
                        // Restaurant panel: show opposite title of admin ledger (بدهکار ↔ بستانکار).
                        const label = isCredit ? "بدهکار" : "بستانکار";
                        return <div key={i.id}
                                    className={`flex flex-col gap-8 p-4 lg:px-8 lg:py-6 w-full border border-gray-300 rounded-xl ${isCredit ? restaurantCreditBorder : restaurantDebitBorder} `}>
                            <p className={`lg:text-lg font-medium ${isCredit ? "text-green-600" : "text-red-600"}`}>{label}</p>
                            <div className="flex items-center w-full flex-wrap gap-4">
                                <div className="pl-4 lg:border-l border-l-gray-600">
                                    <p className="text-sm font-medium">{i.created_at}</p>
                                </div>
                                <div className="pl-4 lg:border-l border-l-gray-600">
                                    <p className="text-sm font-medium">{Number(i.amount).toLocaleString()} تومان </p>
                                </div>
                                {i.notes && <div className="pl-4 lg:border-l border-l-gray-600">
                                    <p className="text-sm font-medium">{i.notes}</p>
                                </div>}
                                <div className="">
                                    <p className="text-sm font-medium">{i.description || (i.tracking_code ? `سفارش کد ${i.tracking_code}` : null)}</p>
                                    {i.code ? <p className="text-sm font-medium pt-1">کد رهگیری: {i.code}</p> : null}
                                </div>
                            </div>
                        </div>
                    }
                )}
            </div>
            <PaginationApp pages={data?.last_page} currentPage={page} onChange={setPage}/>
        </>
    );
};

export default FinancialTransactions;